"use client";

import { useScroll, UseScrollOptions } from "motion/react";
import * as motion from "motion/react-client";
import { ReactNode, useRef } from "react";
import { rh } from "../../hooks";

export function Scroll({
  children,
  options,
  render
}: {
  children?: ReactNode;
  options?: UseScrollOptions;
  render?: (v: rh.ScrollProgressContextValue) => ReactNode;
}) {
  // useScroll() → 基于 window 滚动
  // useScroll({ container }) → 基于 container 滚动
  // useScroll({ target }) → target 基于 viewport 滚动
  // useScroll({ container, target }) → target position relative to container viewport, target 在 container 的可视区域中的位置变化进度

  // offset: [
  //   "target位置 viewport位置", // scrollYProgress = 0，when the top of the target meets the bottom of the container
  //   "target位置 viewport位置" // scrollYProgress = 1，when the bottom of the target meets the top of the container
  // ]
  // offset: ["start end", "end start"] // axis: 'y' : 从元素刚进入 viewport ，到元素完全离开 viewport，这段距离映射到 0~1
  // offset: ["end end", "start start"] // axis: 'y' : 从元素完整进入 viewport，到元素顶部贴 viewport 顶部，这段滚动距离映射到 0~1
  // offset: ["start end", "center center"] // Scroll image reveal effect
  // offset: ["start start", "end end"] // Horizontal scroll section

  const { scrollXProgress, scrollYProgress } = useScroll(options);

  const value = {
    scrollXProgress,
    scrollYProgress,
    type: options?.container?.current ? "container" : "window",
    container: options?.container?.current
  } as rh.ScrollProgressContextValue;

  return (
    <rh.ScrollProgressContext.Provider value={value}>
      {render && render(value)}
      {children}
    </rh.ScrollProgressContext.Provider>
  );
}

export function TrackElementWithinViewport({
  children,
  offset = ["start end", "end start"] // offset = ["end end", "start start"]
}: {
  children: ReactNode;
  offset?: any;
}) {
  const ref = useRef(null);

  return (
    <Scroll options={{ target: ref, offset }}>
      <div ref={ref}>{children}</div>
    </Scroll>
  );
}
